@if (isGlobalMessage) {
  <div id="blue-banner" class="mat-elevation-z1">Welcome to the new Linxio platform. Our upgrade is complete. The previous mobile app won't work with the new platform, and the new Android and iOS apps are expected in a couple of days. Until then, please use the web platform.</div>
} @else {
  <div id="warning-banner" class="mat-elevation-z1" [innerHTML]="bannerText"></div>
}
